import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "text-center"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "collapse",
  id: "consistencyAnalysisLegend"
}
const _hoisted_9 = { class: "table mt-3" }
const _hoisted_10 = { class: "px-0" }
const _hoisted_11 = {
  key: 0,
  class: "progress",
  style: {"height":"30px"}
}
const _hoisted_12 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "btn btn-outline-secondary" }

import { computed } from 'vue'

    import { numCompare } from '@common/Common'

    import type {
        ContextConsistencyAnalysisReadModel,
        PanelistConsistencyAnalysisReadModel
    } from '@Evaluation/CriteriaSurveys/Domain/readmodels'

    import { ConsistencyAnalysisStatus } from '@Evaluation/Model'

    import ConsistencyAnalysisLegend from '@Evaluation/Common/Components/ConsistencyAnalysisLegend.vue'
    import ConsistencyAnalysisCircles from '@Evaluation/Common/Components/ConsistencyAnalysisCircles.vue'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelistConsistencyAnalysisDialog',
  props: {
    propOpened: { type: Boolean },
    propRm: {}
  },
  emits: ["show-question", "close-dialog"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- derived ----------------

    const opened = computed(() => props.propOpened)

    const rm = computed(() => props.propRm)

    const contexts = computed<ContextConsistencyAnalysisReadModel[]>(() =>
        rm.value?.Contexts
            ?.slice() // avoid mutating read model
            .sort((a, b) => numCompare(a.CR, b.CR))
            .reverse()
        ?? []
    )

    // ---------------- helpers ----------------

    function getCssClass(status: ConsistencyAnalysisStatus): string
    {
        if (status === ConsistencyAnalysisStatus.Consistent)
            return 'bg-success'

        if (status === ConsistencyAnalysisStatus.Acceptable)
            return 'bg-warning'

        if (status === ConsistencyAnalysisStatus.Inconsistent)
            return 'bg-danger'

        return ''
    }

    // ---------------- actions ----------------

    function showQuestion(questionId: string)
    {
        emit('show-question', questionId)
    }

    function close()
    {
        emit('close-dialog')
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Consistency analysis", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!rm.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (rm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "bg-light p-2 border mb-0" }, [
                        _createElementVNode("a", {
                          class: "text-dark",
                          "data-toggle": "collapse",
                          "data-target": "#consistencyAnalysisLegend",
                          role: "button"
                        }, [
                          _createElementVNode("i", {
                            class: "fa fa-question-circle-o",
                            "aria-hidden": "true"
                          }),
                          _createTextVNode(" What is inconsistency score? ")
                        ])
                      ], -1 /* CACHED */)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(ConsistencyAnalysisLegend)
                      ]),
                      _createElementVNode("table", _hoisted_9, [
                        _cache[4] || (_cache[4] = _createElementVNode("thead", { class: "thead-light" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { style: {"width":"50px"} }),
                            _createElementVNode("th", null, "Context"),
                            _createElementVNode("th", { class: "px-0" }, "Inconsistency score"),
                            _createElementVNode("th", { style: {"width":"50px"} }),
                            _createElementVNode("th", { style: {"width":"120px"} })
                          ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contexts.value, (c) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: c.CriterionId
                            }, [
                              _createElementVNode("td", null, [
                                _createVNode(ConsistencyAnalysisCircles, {
                                  status: c.Status
                                }, null, 8 /* PROPS */, ["status"])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", null, _toDisplayString(c.CriterionName), 1 /* TEXT */),
                                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _createElementVNode("small", null, _toDisplayString(c.CriterionPath), 1 /* TEXT */)
                              ]),
                              _createElementVNode("td", _hoisted_10, [
                                (c.CR != null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["progress-bar text-dark", getCssClass(c.Status)]),
                                        role: "progressbar",
                                        style: _normalizeStyle({'width': c.CR + '%'})
                                      }, null, 6 /* CLASS, STYLE */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (c.CR == null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Insufficient data "))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("td", null, [
                                (c.CR != null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(c.CR) + "%", 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("td", null, [
                                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode("Review", -1 /* CACHED */)
                                ]))])), [
                                  [_directive_sanitizedHref, c.CriterionUrl]
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})